"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.useRedeemCode = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const providers_1 = require("../../providers");
const react_1 = require("react");
const react_router_dom_1 = require("react-router-dom");
const api_1 = require("../../../service/api");
const organisms_1 = require("../../organisms");
const InvalidDomainPopover_1 = require("../../organisms/RedeemErrorPopovers/InvalidDomainPopover/InvalidDomainPopover");
const EMPTY_CODE = new Array(12).fill('');
// eslint-disable-next-line max-lines-per-function -- refactor, move popovers to separate hook
function useRedeemCode() {
    var _a;
    const [code, setCode] = (0, react_1.useState)(EMPTY_CODE);
    const [error, setError] = (0, react_1.useState)(null);
    const [isLoading, setIsLoading] = (0, react_1.useState)(false);
    const [canRedeem, setCanRedeem] = (0, react_1.useState)(false);
    const [isSuccess, setIsSuccess] = (0, react_1.useState)(false);
    const purchases = (0, providers_1.usePurchases)();
    const navigate = (0, react_router_dom_1.useNavigate)();
    const onCodeChange = (value) => {
        setCode(value);
        setError(null);
        setCanRedeem(value.every(v => v !== ''));
    };
    const clear = () => {
        onCodeChange(EMPTY_CODE);
        setError(null);
    };
    const redeem = () => __awaiter(this, void 0, void 0, function* () {
        setIsLoading(true);
        setIsSuccess(false);
        try {
            yield purchases.redeemCode(code.join(''));
            clear();
            setIsSuccess(true);
        }
        catch (e) {
            if (e instanceof api_1.PurchasesAPIError) {
                setError(e);
            }
            else {
                setError(new Error('Something went wrong, please try again later'));
                console.error(e);
            }
            throw e;
        }
        finally {
            setIsLoading(false);
        }
    });
    let popover = null;
    if (error instanceof api_1.PurchasesAPIError) {
        const organisation = (_a = error === null || error === void 0 ? void 0 : error.payload) === null || _a === void 0 ? void 0 : _a.organization;
        if (!organisation) {
            console.warn('Organisation is not provided in the error payload', error);
        }
        const organisationName = (organisation === null || organisation === void 0 ? void 0 : organisation.organization_name) || '';
        const organisationImage = (organisation === null || organisation === void 0 ? void 0 : organisation.organization_image_url) || '';
        const organisationDomains = (organisation === null || organisation === void 0 ? void 0 : organisation.available_domains)
            ? organisation === null || organisation === void 0 ? void 0 : organisation.available_domains.join(', ')
            : '';
        switch (error.code) {
            case api_1.PurchasesAPIErrorCode.MaxCountReached:
                popover = ((0, jsx_runtime_1.jsx)(organisms_1.MaxCountReachedPopover, { organisationName: organisationName, organisationImageUrl: organisationImage, onClose: clear, "data-e2e": 'useRedeemCode_MaxCountReachedPopover' }));
                break;
            case api_1.PurchasesAPIErrorCode.Expired:
                popover = ((0, jsx_runtime_1.jsx)(organisms_1.ExpiredPopover, { organisationName: organisationName, organisationImageUrl: organisationImage, onClose: clear, "data-e2e": 'useRedeemCode_ExpiredPopover' }));
                break;
            case api_1.PurchasesAPIErrorCode.InvalidDomain:
                const onClose = () => {
                    clear();
                    // @ts-ignore -- use this legacy hack to close profile view. Can be removed once the profile view is displayed with the router
                    if (window.hideProfileView_legacy) {
                        // @ts-ignore
                        window.hideProfileView_legacy();
                    }
                    else {
                        navigate('/hub');
                    }
                };
                popover = ((0, jsx_runtime_1.jsx)(InvalidDomainPopover_1.InvalidDomainPopover, { organisationName: organisationName, organisationImageUrl: organisationImage, organisationDomains: organisationDomains, onClose: onClose, "data-e2e": 'useRedeemCode_InvalidDomainPopover' }));
                break;
            default:
                console.warn('Unhandled error code', error.code, error);
                break;
        }
    }
    return {
        code,
        error,
        isLoading,
        isSuccess,
        redeem,
        canRedeem,
        onCodeChange,
        popover,
    };
}
exports.useRedeemCode = useRedeemCode;
